/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Carrier_Ready_To_DeliverInputs */

const vi_order_action_carrier_ready_to_deliver = /** @type {(inputs: Order_Action_Carrier_Ready_To_DeliverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bàn giao cho bên vận chuyển`)
};

/**

* @param {Order_Action_Carrier_Ready_To_DeliverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_carrier_ready_to_deliver = /** @type {((inputs?: Order_Action_Carrier_Ready_To_DeliverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Carrier_Ready_To_DeliverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_carrier_ready_to_deliver(inputs)
});